import {PlaybookStatusEnum} from "./dto/playbooks-listening.dto";

export const LEGAL_HUB_URL = 'legal-hub';


export type PlaybookStatusTranslationType = {
  [key in PlaybookStatusEnum]: string
}

export const PlaybookStatusTranslation: PlaybookStatusTranslationType ={
    draft: 'Draft playbooks status name (playbooks status) - Draft',
    published: 'Published playbooks status name (playbooks status) - Published'
}